import { useContext } from 'react';

import { TailwindContext } from '../TailwindProvider';

export default function useFormatMessage() {
  const { t } = useContext(TailwindContext);

  return t;
}
